import { useSessionData } from '../auth/SessionDataHook';
import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';

export const useIsAfternoon = () => {
  const { session } = useSessionData();
  const { currentUser } = useCurrentUser();
  const tenantId = session?.identity?.metadata_public?.['tenantId'];

  const isCrawford = currentUser?.id === '89a53825-bb1f-46f1-a598-e28509acdc63';
  const isAfternoon = isCrawford || (tenantId && ['afternoon', 'kim_jenkins'].includes(tenantId));

  return {
    isAfternoon,
    isCrawford,
  };
};
